import { create } from 'zustand';

interface UIState {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  toggleEditing: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  isEditing: false,
  setIsEditing: (isEditing) => set({ isEditing }),
  toggleEditing: () => set((state) => ({ isEditing: !state.isEditing })),
}));
